var _excluded = ["children", "onValidSubmit", "onInvalidSubmit"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import useFormsEngineContext from '../../hooks/useFormsEngineContext';
import useScrollToFirstError from '../../hooks/useScrollToFirstError';
/**
 * This component is a drop in replacement for the <form> html tag, use this when you want to
 * integrate onSubmit event handler to your form.
 */
var Form = _ref => {
  var {
      children,
      onValidSubmit,
      onInvalidSubmit
    } = _ref,
    formProps = _objectWithoutProperties(_ref, _excluded);
  var {
    handleSubmit
  } = useFormsEngineContext();
  useScrollToFirstError();
  return /*#__PURE__*/React.createElement("form", _extends({}, formProps, {
    onSubmit: e => onValidSubmit && handleSubmit(onValidSubmit, onInvalidSubmit)(e)
  }), children);
};
export default Form;